import React from 'react';
import './About.css';

function About() {
  return (
    <section className="about-section" id="about">
      <div className="about-inner">
        <div className="about-photo reveal">
          <img src="/images/author-photo-2.jpeg" alt="Atiba — Author" />
        </div>
        <div className="about-text reveal">
          <div className="section-label">
            <div className="red-bar"></div>
            <span>About the Author</span>
          </div>
          <h2>MEET ATIBA</h2>
          <p>
            <strong>Atiba</strong> is a storyteller drawn to the intersection of power, justice, and the human cost of political ambition. With <em>Saving Grace</em>, he delivers a debut thriller that pulls readers into a world where the line between public service and private corruption is dangerously thin.
          </p>
          <p>
            When he's not writing, Atiba can be found exploring the corridors of American history and policy that inspire his fiction — always searching for the next story hiding in plain sight.
          </p>
          <p>
            <em>Saving Grace</em> is his first novel.
          </p>
        </div>
      </div>
    </section>
  );
}

export default About;
